import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    Button,
    Modal,
    ModalComponent,
    ModalProps,
    Typography,
} from '@speeki/global-ui-components';

import { getPath } from '@services/RouteService/paths';

import {
    resetReporterDetails,
    subsidiarySiteVar,
} from '@boot/reactiveVariables';

interface LeaveConfirmationModalProps extends Pick<
    ModalProps,
    'onClose' | 'open'
> {}

export const LeaveConfirmationModal = ({
    onClose,
    open,
}: LeaveConfirmationModalProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const closeReport = () => {
        resetReporterDetails();
        subsidiarySiteVar(undefined);
        navigate(getPath({ path: '/' }));
    };

    return (
        <ModalComponent
            onClose={onClose}
            open={open}
            preventCloseEsc
            preventCloseOutside
            width={648}
        >
            <Modal.Content>
                <Modal.TitleSecondary center>
                    {t('LEAVE_TITLE')}
                </Modal.TitleSecondary>
                <Typography.TextBody_16_24>
                    {t('LEAVE_INFO')}
                </Typography.TextBody_16_24>
            </Modal.Content>
            <Modal.Footer>
                <Modal.ButtonsWrapper>
                    <Button
                        onClick={onClose}
                        testId="button_cancel"
                        variant={'secondary'}
                    >
                        {t('CANCEL')}
                    </Button>
                    <Button
                        onClick={() => {
                            onClose();
                            closeReport();
                        }}
                        testId="button_leave"
                        variant={'primary'}
                    >
                        {t('LEAVE')}
                    </Button>
                </Modal.ButtonsWrapper>
            </Modal.Footer>
        </ModalComponent>
    );
};
